export default __webpack_public_path__ + "static/media/course7.fc528417.png";